import React from "react";
import { Modal, Card } from "ui-kit-ck-consultant";

import anomalyDescriptions from "../../utils/anomalyDescriptions";

const ModalAnomalyParams = ({ show, onClose, folder }) => {
  if (!folder) {
    return <Modal title="Détails de l'anomalie" show={show} onClose={onClose} />;
  }

  const description = anomalyDescriptions[folder.label];
  const params = folder.params || null;

  return (
    <Modal title="Détails de l'anomalie" show={show} onClose={onClose}>
      <h2 className="mb-10">{folder.label}</h2>
      {folder.reference ? (
        <p className="mb-10">
          <strong>Référence dossier :</strong> {folder.reference}
        </p>
      ) : null}

      {description ? (
        <>
          <h3>Critères de déclenchement</h3>
          <Card className="bg-gray mb-20" style={{ padding: "10px" }}>
            {description}
          </Card>
        </>
      ) : null}

      <h3>Paramètres du dossier</h3>
      {params && Object.keys(params).length > 0 ? (
        <Card className="bg-gray" style={{ padding: "10px" }}>
          {Object.entries(params).map(([key, value]) => (
            <div
              key={key}
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
                padding: "4px 0",
              }}
            >
              <span>{key}</span>
              <strong style={{ textAlign: "right" }}>
                {value === null || value === undefined || value === ""
                  ? "—"
                  : String(value)}
              </strong>
            </div>
          ))}
        </Card>
      ) : (
        <Card className="bg-gray" style={{ padding: "10px" }}>
          Paramètres non disponibles (anomalie générée avant l'ajout de cette
          fonctionnalité).
        </Card>
      )}
    </Modal>
  );
};

export default ModalAnomalyParams;
